import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';
import User from 'core/entities/UserObject';
import i18n from 'locales/i18n';

class LoggedUserStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'LOGGED_USER_CHANGE_EVENT';
        const NAME = 'LOGGED_USER_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        // currentUser
        this.currentUser = null;

        // if he is waiting to login
        this.isLoading = false;

        this.currentLanguage = i18n.getCurrentLanguage();

        this.rights = [];
    }

    isLogged() {
        if (this.currentUser) {
            return this.currentUser.isLogged;
        }
        return false;
    }

    isLoading() {
        return this.isLoading;
    }

    sign(data) {
        this.currentUser = new User(data);
        this.currentUser.isLogged = true;
    }

    getCurrentUser() {
        return this.currentUser;
    }

    getCurrentLanguage() {
        return this.currentLanguage;
    }

    getCurrentRights() {
        return this.rights;
    }

    isAuthorized(routeName) {
        if (!routeName || this.rights.includes(routeName) === true)
            return true;
        return false;
    }

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        case Constants.LOGOUT:
            this._initStore();
            this._emitChange();
            break;
        case Constants.LOGIN:
            this.sign(action.value);
            this._emitChange();
            break;
        case Constants.LOGIN_START:
            this.isLoading = true;
            this._emitChange();
            break;
        case Constants.LOGIN_FAILED:
            this.isLoading = false;
            this._emitChange();
            break;
        case Constants.CHANGE_LANGUAGE:
            this.currentLanguage = action.value.language;
            this._emitChange();
            break;
        case Constants.INIT_RIGHTS:
            this.rights = action.value;
            this._emitChange();
            break;
        default:
            return false;
        }
    }
}

export default new LoggedUserStore();
